// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b0wC","textarea":"styles_textarea__2U0mg"};